import React, { useState, useEffect } from 'react';
import AIFindContactsModal from './modals/AIFindContactsModal';
import AIEnrichModal from './modals/AIEnrichModal';

function AIModalManager({ modalType, client, onClose, onDataChanged }) {
  if (!modalType || !client) return null;

  if (modalType === 'find') {
    return <AIFindContactsModal isOpen={true} onClose={onClose} client={client} onContactsSaved={onDataChanged} />;
  }
  if (modalType === 'enrich') {
    return <AIEnrichModal isOpen={true} onClose={onClose} client={client} onEnrichmentApplied={onDataChanged} />;
  }
  return null;
}

export default AIModalManager;
